<template>
  <div>
    <add-companies-group-component
      v-if="this.companies.length > 0"
      :companies-group-data-prop="null"
     /> 

  </div>
    
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import AddCompaniesGroupComponent from "../../components/AddCompaniesGroupComponent";

  export default {
    name: "Edit",
    components: {AddCompaniesGroupComponent},
    data() {
      return {
        isEdit: false,
      }
    },
    async created() {
      if(this.companies.length === 0){
        this.$vs.loading({ text: 'Loading Companies' })
        await this.loadAllCompanies({
            storeName: 'companies',
            url: `admin/companies`,
            commitUrl: 'companies/SET_COMPANIES',
        })
        this.$vs.loading.close()
      }
    },
    computed: {
      ...mapGetters({
        companies: 'companies/companiesList',
        isLoading: 'companiesGroups/isLoading',
        error: 'companiesGroups/error',
      })
    },
    methods: {
      ...mapActions({
        loadAllCompanies: 'get'
      })
    }
  }
</script>
